export const common = {
    services: [{
        id:1,
        title: "Infor M3 Consulting Services",
        description: "At SSNM3 Technologies, we offer specialized services for Infor M3 a robust ERP solution designed for complex, global operations in industries like manufacturing, distribution, food & beverage, fashion, and equipment. Our team provides end-to-end support to ensure your Infor M3 environment is optimized, scalable, and aligned with your business goals.",
        delay: 300
    },{
        id:2,
        title: "SAP Consulting Services",
        description: "At SSNM3 Technologies, we specialize in delivering comprehensive SAP consulting services to help businesses streamline operations, improve efficiency, and drive digital transformation. Whether you're just getting started with SAP or looking to enhance your existing SAP landscape, our expert consultants are here to support you every step of the way.",
        delay: 200
    },{
        id:3,
        title: "Website Development Services",
        description: `At SSNM3 Technologies, we craft high-performing, visually engaging websites that don’t just look great they drive results. Whether you're a startup building your first digital presence or an enterprise looking to modernize, our web development team brings creativity, technical excellence, and business insight to every project.
        We combine design-thinking with powerful development frameworks to build websites that are fast, secure, mobile-friendly, and optimized for user experience.`,
        delay: 400
    }]
}